import { SearchResults } from "../../Shared/scriptts/interfaces";
import { params, executeSearchUrl, brandedSearch, displayResults } from '../search-main';
import { addToArrayParam, isBrandedSearchFilter, removeFromArrayParam } from '../search-filters-main';
import { debounce } from "../../Shared/scriptts/utilities";

declare var gIsSearchFiltersEnabled: boolean;
declare var series: any;

const groupNameIndex = 5;
const seriesNameIndex = 7;

let showNoCountSeries = false;
let noCountSeries: HTMLLIElement[] = [];
let foundSeries: HTMLLIElement[] = [];
let seriesGroups: HTMLLIElement[] = [];
let searchResults: SearchResults;
let selectedSeries: string[] = [];
let showAllSeries: boolean = false;

const countIcon = document.createElement('span');

export function resetSeriesFilter() {
    selectedSeries = [];
    setClearButtonState();
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelector<HTMLButtonElement>('#apply-filters-series')?.addEventListener('click', applyButtonClicked);
    document.querySelector<HTMLButtonElement>('#clear-filters-series')?.addEventListener('click', clearButtonClicked);
    if (gIsSearchFiltersEnabled) {
        document.querySelector<HTMLInputElement>('#series-search')?.addEventListener('keyup', debounce(() => buildSeriesFilterTemp(document.querySelector<HTMLInputElement>('#series-search')?.value), 500));
        document.querySelector<HTMLInputElement>('#show-all-series')?.addEventListener('change', showAllSeriesChanged);
    }
    else {
        document.querySelector<HTMLInputElement>('#series-search')?.addEventListener('keyup', seriesSearchKeyup);
    }
    // todo: remove this listener and associated event handler when we no longer need the SearchFilters feature toggle.
    document.querySelector<HTMLButtonElement>('#filter-series-showall-toggle')?.addEventListener('click', showAllToggleClicked);
});

/**
 * Display the occupational series filter
 * @param data The data returned from the search API
 */
export function displaySeriesFilter(data: SearchResults) {
    if (gIsSearchFiltersEnabled) {
        searchResults = data;
        buildSeriesFilterTemp();
        return;
    }

    buildSeriesFilter(data);
    const titleElem = document.querySelector<HTMLElement>('#titleaccordion-series');
    if (titleElem !== null) {
        countIcon.className = params.JobCategoryCode?.length > 0 ? 'bg-warning rounded-full py-1 px-2 ml-2' : 'bg-warning rounded-full py-1 px-2 ml-2 hidden';
        countIcon.innerText = params.JobCategoryCode?.length.toString();
        if (!titleElem.contains(countIcon)) {
            titleElem.appendChild(countIcon);
        }
    }
}

// todo: This becomes the new buildSeriesFilter function when we no longer need the SearchFilters feature toggle.
function buildSeriesFilterTemp(searchText: string = '') {
    const seriesContainer = document.querySelector<HTMLUListElement>('#filter-series-list');
    if (seriesContainer === null) {
        return;
    }
    noCountSeries = [];
    seriesGroups = [];
    searchText = searchText.toLowerCase();

    const isSearch = searchText.length > 2;
    const brandedSearchSeries = !brandedSearch ? null : brandedSearch.JobCategoryCode;
    const isFilterSelectable = !brandedSearchSeries || brandedSearchSeries.length === 0;
    const listFragment = document.createDocumentFragment();
    const codeCounts = searchResults?.f?.j;
    let jobCodes: string[] = [];
    let foundSeries: string[] = [];

    for (const s in series) {
        if (!series[s].hasOwnProperty('Children')) {
            continue;
        }
        jobCodes.push(s);
    }

    jobCodes.sort();
    seriesContainer.innerHTML = '';

    if (!isFilterSelectable) {
        document.querySelector<HTMLElement>('#clear-filters-series')?.classList.add('hidden');
    }

    jobCodes.forEach(groupCode => {
        const groupLi = document.createElement('li');
        const groupCheckbox = document.createElement('input');
        const groupLabel = document.createElement('label');
        const groupJobName = series[groupCode].Name.substring(groupNameIndex);
        const seriesUl = document.createElement('ul');
        const groupContainer = document.createElement('div');
        const isFamilySearch = isSearch && groupCode.toLowerCase() === searchText;
        let allChecked = true;
        let seriesJobCount = 0;

        groupContainer.className = isSearch && !isFamilySearch ? 'hidden' : 'flex items-start';

        groupCheckbox.type = 'checkbox';
        groupCheckbox.name = 'occupation_series';
        groupCheckbox.value = groupCode;
        groupCheckbox.id = `series-id-${groupCode}`;
        groupCheckbox.className = 'mr-1';
        groupCheckbox.addEventListener('change', seriesGroupChanged);
        groupCheckbox.disabled = !isFilterSelectable;

        groupLabel.className = 'm-0';
        groupLabel.setAttribute('for', groupCheckbox.id);
        groupLabel.textContent = `${groupCode} – ${groupJobName}`;

        groupContainer.appendChild(groupCheckbox);
        groupContainer.appendChild(groupLabel);
        groupLi.appendChild(groupContainer);

        for (const seriesCode in series[groupCode].Children) {
            if (!isFilterSelectable && brandedSearchSeries.indexOf(seriesCode) === -1) {
                continue;
            }

            const jobCount = codeCounts && seriesCode in codeCounts ? codeCounts[seriesCode] : 0;
            const isInSearch = isSearch && (isFamilySearch || seriesCode.includes(searchText) || series[groupCode]?.Children[seriesCode]?.Name?.toLowerCase().includes(searchText));
            const checked = selectedSeries.includes(seriesCode) || params.JobCategoryCode?.indexOf(seriesCode) > -1;
            const seriesLi = getSeriesListItem(groupCode, seriesCode, checked, !isFilterSelectable, jobCount);

            if (!seriesLi || (isSearch && !isInSearch)) {
                continue;
            }

            if (!checked) {
                allChecked = false;
            }

            seriesUl.className = `mt-1 space-y-2 ${!isSearch || isFamilySearch ? 'ml-6' : ''}`;
            seriesUl.appendChild(seriesLi);
            groupLi.appendChild(seriesUl);

            if ((isSearch && isInSearch) || jobCount > 0 || checked || showAllSeries) {
                ++seriesJobCount;
                seriesLi.classList.remove('hidden');

                if (!foundSeries.includes(seriesCode)) {
                    foundSeries.push(seriesCode);
                }
            }
            else if (jobCount === 0 && !showAllSeries && !checked) {
                seriesLi.classList.add('hidden');
            }

            if (checked && !selectedSeries.includes(seriesCode)) {
                selectedSeries.push(seriesCode);
            }
        }

        if (seriesJobCount === 0 && !isSearch) {
            groupLi.className = 'hidden';
        }
        else {
            groupCheckbox.checked = allChecked;
        }

        listFragment.appendChild(groupLi);
    });

    if (isSearch) {
        selectedSeries.forEach(code => {
            if (!foundSeries.includes(code)) {
                const seriesLi = getSeriesListItem(`${code.substring(0, 2)}00`, code, true, !isFilterSelectable, 0);
                if (!seriesLi) {
                    return;
                }

                listFragment.appendChild(seriesLi);
            }
        });

        if (foundSeries.length === 0) {
            document.querySelector<HTMLElement>('#filter-series-no-results')?.classList.remove('hidden');
        }
        else {
            document.querySelector<HTMLElement>('#filter-series-no-results')?.classList.add('hidden');
        }
    }
    else {
        document.querySelector<HTMLElement>('#filter-series-no-results')?.classList.add('hidden');
    }

    seriesContainer.appendChild(listFragment);
    setFilterButtonState();
}

function getSeriesListItem(groupCode: string, seriesCode: string, isChecked: boolean, isDisabled: boolean, jobCount: number): HTMLLIElement | null {
    const seriesLi = document.createElement('li');
    const seriesCheckbox = document.createElement('input');
    const seriesLabel = document.createElement('label');
    const seriesName = series[groupCode]?.Children[seriesCode]?.Name?.substring(seriesNameIndex);

    if (!seriesName) {
        return null;
    }

    seriesCheckbox.type = 'checkbox';
    seriesCheckbox.name = 'occupation_series';
    seriesCheckbox.value = seriesCode;
    seriesCheckbox.id = `series-id-${seriesCode}`;
    seriesCheckbox.className = 'mr-1';
    seriesCheckbox.checked = isChecked;
    seriesCheckbox.disabled = isDisabled;
    seriesCheckbox.addEventListener('change', seriesInputChanged);

    seriesLabel.textContent = `${seriesCode} – ${seriesName} (${jobCount})`;
    seriesLabel.className = 'm-0';
    seriesLabel.setAttribute('for', seriesCheckbox.id);

    seriesLi.className = 'flex items-start';

    seriesLi.appendChild(seriesCheckbox);
    seriesLi.appendChild(seriesLabel);

    return seriesLi;
}
function showAllSeriesChanged() {
    const showAllInput = document.querySelector<HTMLInputElement>('#show-all-series');
    if (!showAllInput) {
        return;
    }
    showAllSeries = showAllInput.checked;
    buildSeriesFilterTemp(document.querySelector<HTMLInputElement>('#series-search')?.value);
}

function seriesGroupChanged(evt: Event) {
    const groupElem = (<HTMLInputElement>evt.target);

    groupElem.closest('li')?.querySelectorAll('input').forEach(input => {
        const inputLi = input.closest('li');

        if (!inputLi) {
            return;
        }

        input.checked = groupElem.checked;

        if (input.checked && !selectedSeries.includes(input.value)) {
            selectedSeries.push(input.value);
            inputLi.classList.remove('hidden');
        }
        else {
            const index = selectedSeries.indexOf(input.value);

            if (index > -1) {
                selectedSeries.splice(index, 1);
            }
        }
    });

    setClearButtonState();
}

function seriesInputChanged(evt: Event) {
    setClearButtonState();
    const seriesInput = (<HTMLInputElement>evt.target);
    const group = `${seriesInput.value.substring(0, 2)}00`;
    const groupInput = document.querySelector<HTMLInputElement>(`[value="${group}"]`);
    if (!groupInput) {
        return;
    }

    const seriesContainer = seriesInput.closest('ul');

    if (!seriesInput.checked) {
        groupInput.checked = false;

        const index = selectedSeries.indexOf(seriesInput.value);

        if (index > -1) {
            selectedSeries.splice(index, 1);
        }
    }
    else {
        if (!selectedSeries.includes(seriesInput.value)) {
            selectedSeries.push(seriesInput.value);
        }

        groupInput.checked = seriesContainer?.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').length === seriesContainer?.querySelectorAll<HTMLInputElement>('input[type="checkbox"]:checked').length;
    }
}

function applyButtonClicked() {
    const seriesContainer = document.querySelector<HTMLUListElement>('#filter-series-list');
    if (!seriesContainer) {
        return;
    }

    seriesContainer.querySelectorAll('input').forEach(input => {
        if (input.value.endsWith('00')) {
            return;
        }

        if (input.checked) {
            addToArrayParam('JobCategoryCode', input.value);
        }
        else {
            removeFromArrayParam('JobCategoryCode', input.value);
        }
    });

    params.Page = '1';
    setFilterButtonState();
    displayResults(executeSearchUrl, false, true);
}

function clearButtonClicked() {
    const searchInput = document.querySelector<HTMLInputElement>('#series-search');

    params.JobCategoryCode = [];
    selectedSeries = [];

    if (searchInput) {
        searchInput.value = '';
    }

    document.querySelector<HTMLUListElement>('#filter-series-list')?.querySelectorAll('input').forEach(input => {
        input.checked = false;
    });
    
    params.Page = '1';
    document.querySelector<HTMLButtonElement>('#clear-filters-series')?.classList.add('hidden');
    setFilterButtonState();
    displayResults(executeSearchUrl, false, true);
}

function setFilterButtonState() {
    const filterButton = document.querySelector<HTMLButtonElement>('#filter-button-series');
    const buttonTextElem = document.querySelector<HTMLElement>(`#filter-button-text-series`);
    if (!filterButton || !buttonTextElem) {
        return;
    }

    if (params.JobCategoryCode.length === 0) {
        buttonTextElem.textContent = 'Occupation';
        filterButton.classList.remove('button-search-filter-applied');
        filterButton.classList.add('button-search-filter');
        filterButton.querySelectorAll<HTMLElement>('svg').forEach(icon => {
            icon.classList.remove('fill-white');
            icon.classList.add('fill-gray-darkest');
        });
    }
    else {
        const seriesCode = params.JobCategoryCode[0];
        const groupCode = `${seriesCode.substring(0, 2)}00`;
        const seriesName = series[groupCode]?.Children?.[seriesCode]?.Name?.substring(seriesNameIndex) ?? seriesCode;

        buttonTextElem.textContent = `${seriesName}${params.JobCategoryCode.length > 1 ? ` + ${params.JobCategoryCode.length - 1}` : ''}`;
        filterButton.classList.add('button-search-filter-applied');
        filterButton.classList.remove('button-search-filter');
        filterButton.querySelectorAll<HTMLElement>('svg').forEach(icon => {
            icon.classList.add('fill-white');
            icon.classList.remove('fill-gray-darkest');
        });
    }
}

function setClearButtonState() {
    const clearButton = document.querySelector<HTMLButtonElement>('#clear-filters-series');
    const seriesContainer = document.querySelector<HTMLUListElement>('#filter-series-list');
    if (!clearButton || !seriesContainer) {
        return;
    }

    if (seriesContainer.querySelector('input[type="checkbox"]:checked') !== null) {
        clearButton.classList.remove('hidden');
    }
    else {
        clearButton.classList.add('hidden');
    }
}

// todo: It will be safe to delete all functions below when we no longer need the SearchFilters feature toggle.
function buildSeriesFilter(data: SearchResults, searchText: string = '') {
    const seriesContainer = document.querySelector<HTMLUListElement>('#filter-series-list');
    if (seriesContainer === null) {
        return;
    }
    const isSearch = searchText.length > 2;
    const brandedSearchSeries = !brandedSearch ? null : brandedSearch.JobCategoryCode;
    const isFilterSelectable = !brandedSearchSeries || brandedSearchSeries.length == 0;
    let jobCodes: string[] = [];
    for (const s in series) {
        jobCodes.push(s);
    }
    jobCodes.sort();
    seriesContainer.innerHTML = '';
    if (!isFilterSelectable) {
        document.querySelector<HTMLElement>('#series-search-container')?.classList.add('hidden');
        document.querySelector<HTMLElement>('#filter-series-showall-toggle')?.classList.add('hidden');
        document.querySelector<HTMLElement>('#filter-series-showall-toggle')?.classList.add('md:hidden');
    }

    jobCodes.forEach(jobCode => {
        const groupLI = document.createElement('li');
        const groupUL = document.createElement('ul');
        let seriesJobCount = 0;

        groupLI.innerHTML = `<h4 class="mt-4 border-b border-gray-lighter text-primary-darker text-lg${isSearch || !isFilterSelectable ? ' hidden' : ''}">${series[jobCode].Name}</h4>`;
        groupUL.className = 'space-y-1';

        for (const seriesCode in series[jobCode].Children) {
            if (!isFilterSelectable && brandedSearchSeries.indexOf(seriesCode) === -1) {
                continue;
            }
            const count: string = (data['f']['j'][seriesCode] ?? '0').toString();
            const li = document.createElement('li');
            const input = document.createElement('input');
            const label = document.createElement('label');
            const checked = params.JobCategoryCode?.indexOf(seriesCode) > -1;

            input.type = 'checkbox';
            input.name = 'occupation_series';
            input.value = seriesCode;
            input.id = `series-id-${seriesCode}`;
            input.checked = checked;
            input.addEventListener('change', seriesChanged);
            input.disabled = !isFilterSelectable;

            label.innerHTML = `${series[jobCode].Children[seriesCode].Name} <span class="text-gray text-sm">(${count})</span>`;
            label.setAttribute('for', input.id);

            li.id = `series-li-${seriesCode}`;
            li.setAttribute('data-count', count);
            li.appendChild(input);
            li.appendChild(label);

            if (!isBrandedSearchFilter('JobCategoryCode', seriesCode) && count === '0' && !showNoCountSeries) {
                noCountSeries.push(li);
                if (showNoCountSeries === false) {
                    li.classList.add('hidden');
                }
            }
            else {
                ++seriesJobCount;
            }

            groupUL.appendChild(li);
        }

        groupLI.appendChild(groupUL);

        if (seriesJobCount < 1) {
            groupLI.classList.add('hidden');
        }

        seriesContainer.appendChild(groupLI);
        seriesGroups.push(groupLI);
    });
}

function setSeriesFilterDisplay() {
    const searchLength = document.querySelector<HTMLInputElement>('#series-search')?.value.length ?? 0;
    document.querySelector<HTMLUListElement>('#filter-series-list')?.querySelectorAll<HTMLLIElement>('li').forEach(li => {
        const found = foundSeries.indexOf(li) > -1;
        const inNoCountList = noCountSeries.indexOf(li) > -1;

        if (li.querySelector<HTMLInputElement>('input')?.checked || (inNoCountList && showNoCountSeries && (searchLength < 3 || found)) || (!inNoCountList && (searchLength < 3 || found))) {
            li.classList.remove('hidden');
        }
        else {
            li.classList.add('hidden');
        }
    });

    seriesGroups.forEach(groupList => {
        let showGroup = false;

        if (searchLength > 2) {
            groupList.querySelector('h4')?.classList.add('hidden');
        }
        else {
            groupList.querySelector('h4')?.classList.remove('hidden');
        }

        groupList.querySelectorAll<HTMLLIElement>('li').forEach(li => {
            if (!li.classList.contains('hidden')) {
                showGroup = true;
            }
        });

        if (showGroup) {
            groupList.classList.remove('hidden');
        }
        else {
            groupList.classList.add('hidden');
        }
    });
}

function seriesChanged(evt: Event) {
    const seriesInput = <HTMLInputElement>(evt.target);
    if (seriesInput.checked) {
        addToArrayParam('JobCategoryCode', seriesInput.value);
    }
    else {
        removeFromArrayParam('JobCategoryCode', seriesInput.value);
    }
    if (params.JobCategoryCode.length > 0) {
        countIcon.innerText = params.JobCategoryCode.length.toString();
        countIcon.classList.remove('hidden');
    }
    else {
        countIcon.innerText = '0';
        countIcon.classList.add('hidden');
    }

    displayResults(executeSearchUrl, false, true);
}

function seriesSearchKeyup(evt: Event) {
    const searchInput = <HTMLInputElement>(evt.target);
    const seriesFilterList = document.querySelector<HTMLUListElement>('#filter-series-list')?.querySelectorAll('li');
    if (!seriesFilterList) {
        return;
    }

    const searchText = searchInput.value.toLowerCase();
    foundSeries = [];
    seriesFilterList.forEach(li => {
        const seriesCode = li.id.substring(li.id.lastIndexOf('-') + 1);
        const seriesGroup = `${seriesCode.substring(0, 2)}00`;
        const seriesInput = document.querySelector<HTMLInputElement>(`#series-id-${seriesCode}`);

        if (seriesInput === null) {
            return;
        }
        if (searchInput.value.length < 3) {
            document.querySelector<HTMLButtonElement>('#filter-series-showall-toggle')?.classList.remove('md:hidden');
        }
        else {
            const found = series[seriesGroup]?.Children[seriesCode]?.Name.toLowerCase().includes(searchText);
            if (found === true) {
                foundSeries.push(li);
            }
        }
    });

    setSeriesFilterDisplay();
}

function showAllToggleClicked() {
    const toggleButton = document.querySelector<HTMLButtonElement>('#filter-series-showall-toggle');
    if (toggleButton === null) {
        return;
    }

    showNoCountSeries = !showNoCountSeries;
    toggleButton.innerText = showNoCountSeries ? 'Hide options with 0 jobs' : 'Show options with 0 jobs';
    setSeriesFilterDisplay();
}
